<div class="panel panel-default" style="margin-bottom:10px" *ngIf="_meta | async as m">
  <div class="panel-heading" style="cursor: pointer;" (click)="getItems()">
    <h4 class="panel-title">
      <a role="button">
        <i *ngIf="IsCollapsed && !loading && (!items || items.length !== 0)"
           class="pull-left fa fa-chevron-down"></i>
        <i *ngIf="items && !IsCollapsed && !loading && items.length !== 0" class="pull-left fa fa-chevron-up"></i>
        <span *ngIf="loading"><i class="pull-left fa fa-pulse fa-spinner"></i></span>
<!--        <span *ngIf="meta.sort_attribute && items && items.length === 0"><i style="padding-right: 3px" class= "fa fa-info-circle"-->
<!--           ngbTooltip="Click again to open and drop sites into group"></i></span>-->
        <span *ngIf="items && items.length === 0">No</span>
        <span *ngIf="m.verbose_name_plural">
          {{ m.verbose_name_plural }}
        </span>
        <span *ngIf="!m.verbose_name_plural">{{ m.verbose_name }}</span>

        <span *ngIf="m.symbol">
                        <img *ngIf="m.symbol.contentType | isImage" [src]="m.symbol.url"/>
                    </span>
      </a>
      <div *ngIf="m.permissions && m.permissions.write && !m.hide_add_button" class="pull-right"
            style="position: sticky; right: 0;">
                                <span style="cursor: pointer;"
                                      (click)="m.permissions.write && m.type !== undefined &&
                                      open(foreignKey, {}, $event)">
                                    Add {{ m.verbose_name }}
                                  <i class="fa fa-plus-circle"></i></span>
      </div>

      <div *ngIf="m.permissions && m.permissions.write && m.items" class="pull-right">
        <span *ngIf="m.permissions && m.permissions.write && m.items && !surveyLoading" style="cursor: pointer; vertical-align: middle;"
              (click)="submitSurveyFeatures(items)">
        Submit to Survey123
        <i class="fa fa-envelope" style="padding-right:10px"></i>
      </span>
        <span *ngIf="surveyLoading">
        <i style="padding:0px 30%; color: #000;"
           class="fa fa-spinner fa-pulse">
        </i></span>

      </div>
    </h4>
  </div>

  <div cdkDropListGroup class="panel-body" *ngIf="items && items.length > 0 && !loading && !m.sort_attribute"
       [ngbCollapse]="IsCollapsed">
    <table class="table table-striped">
      <thead>
      <tr cdkDropList
          id="{{ parentItem }}"
          (cdkDropListDropped)="drop($event.previousIndex,  $event.currentIndex, items, $event)"
          [cdkDropListData]="items">
        <ng-template ngFor let-key [ngForOf]="m.display_fields">
          <th *ngIf="m.fields[key] && (m.fields[key].type !== 'field' || (m.fields[key].type === 'field' &&
                     m.fields[key].get_choices !== undefined) ||
                     (m.fields[key].type === 'field' &&
                     m.fields[key].read_only === true))"
              [innerHTML]="m.fields[key].label | toTrusted">
            {{key}}
          </th>
        </ng-template>
        <th *ngIf="m.notify !== undefined" style="width:25px">Notify</th>
        <th *ngIf="m.print !== undefined" style="width:25px">Print</th>
        <th *ngFor="let button of m.action_buttons" style="width: 25px;">{{button.label}}</th>
        <th *ngIf="m.permissions && m.permissions.write && !m.hide_delete_button" style="width:25px">Delete</th>
      </tr>

      </thead>
      <!-- Moved ng-repeat from tbody to tr -->
      <tbody>
      <ng-template ngFor let-item [ngForOf]="items" let-index="index">
        <tr
          [ngStyle]="m.subItems ? {'border-left': '#ddd 1px solid', 'border-top': '#ddd 1px solid', 'border-right': '#ddd 1px solid'} : null">
          <ng-template ngFor let-key [ngForOf]="m.display_fields">
            <td *ngIf="m.fields[key] && (m.fields[key].type !== 'field' || (m.fields[key].type === 'field' &&
        m.fields[key].get_choices !== undefined) ||
      (m.fields[key].type === 'field' &&
        m.fields[key].read_only === true))"
                [ngStyle]="m.permissions && m.permissions.write && !item.prevent_edits? {'cursor': 'pointer'} : null"
                (click)="!item.prevent_edits && m.permissions && m.permissions.write && m !== undefined
                                              && open(foreignKey, item, $event)">
              <app-display-field [type]="m.fields[key].type" [value]="item[key]"
                                 [getChoices]="m.fields[key].get_choices"
                                 [choices]="m.fields[key].choices"></app-display-field>
            </td>
          </ng-template>
          <td *ngIf="m.notify !== undefined" style="cursor: pointer; vertical-align: middle;">
            <a (click)="m.notify.click(item)">
              <i class="fa fa-envelope fa-lg" style="padding:0px 30%; color: #000;"></i>
            </a>
          </td>
          <td *ngIf="m.print !== undefined" style="cursor: pointer; vertical-align: middle;">
            <a (click)="get(item, index)" *ngIf="!itemLoading[index]">
              <i class="fa fa-print fa-lg" style="padding:0px 30%; color: #000;"></i>
            </a>
            <span *ngIf="itemLoading[index]"><i style="padding:0px 30%; color: #000;"
                                                class="fa fa-spinner fa-pulse"></i></span>
          </td>
          <td *ngFor="let button of m.action_buttons" style="cursor: pointer; vertical-align: middle;">
            <a (click)="button.func(item)">
              <i class [ngClass]="'fa ' + button.icon + ' fa-lg'" style="padding:0px 30%; color: #000;"></i>
            </a>
          </td>
          <td *ngIf="m.permissions && m.permissions.write && !m.hide_delete_button && !item.prevent_edits"
              style="cursor: pointer; vertical-align: middle;"
              (click)="delete(item)"><i
            class="fa-regular fa-times-circle fa-lg"
            style="padding:0px 30%;"></i></td>
        </tr>
        <tr *ngIf="m.subItems"
            style="border-left: #ddd 1px solid; border-bottom: #ddd 1px solid; border-right: #ddd 1px solid;
                       background: none;">
          <td [attr.colspan]="(m.display_fields.length + (m.action_buttons ? m.action_buttons.length : 0))+3"
              style="padding-bottom: 0">

                    <span *ngFor="let subItemKey of m.subItems">
                        <app-nested-inline *ngIf="subItemKey.indexOf('attachment') < 0 && subItemKey.indexOf('review') < 0
                                                && item.globalid !== undefined && subItemKey.indexOf('payment') < 0 &&
                                                 subItemKey.indexOf('locations') < 0"
                                           [meta]="m[subItemKey]" [parentItem]="item"
                                           [foreignKey]="item.globalid"></app-nested-inline>

                        <app-attachments *ngIf="subItemKey.indexOf('attachment') > -1 && item.globalid !== undefined && !m.listAttachments"
                                         [type]="m[subItemKey].type" [foreignKey]="item.globalid"
                                         [useVerboseName]="m[subItemKey].use_verbose_name"></app-attachments>
                        <app-attachments-inline *ngIf="subItemKey.indexOf('attachment') > -1 && item.globalid !== undefined && m.listAttachments"
                                       [type]="m[subItemKey].type" [foreignKey]="item.globalid"
                                       [useVerboseName]="m[subItemKey].use_verbose_name" [displayFields]="m[subItemKey].display_fields"></app-attachments-inline>
                        <app-routing-review *ngIf="subItemKey.indexOf('review') > -1 && item.globalid !== undefined"
                                            [contentType]="m.content_type"
                                            [foreignKey]="item.globalid"></app-routing-review>
                        <app-payments-inline *ngIf="subItemKey.indexOf('payment') > -1 && item.globalid !== undefined"
                                             [contentType]="m.content_type" [parentService]="genericService"
                                             [meta]="m[subItemKey]" [parentItem]="item"></app-payments-inline>
                       <app-nested-inline *ngIf="subItemKey.indexOf('locations') > -1"
                                         [meta]="m[subItemKey]" [items]="item[subItemKey]" [parentItem]="item"
                                         [foreignKey]="item.globalid" [sorting]="item.groupname"></app-nested-inline>
                    </span>
          </td>
        </tr>
        <tr *ngIf="m.subItems">
          <td [attr.colspan]="m.display_fields.length+3" style="background: none"></td>
        </tr>
      </ng-template>
      </tbody>
    </table>
    <div *ngIf="items.length < m.count">
      <div class="row">
        <div class="col-md-12">
          <p class="text-center">
            <a role="button" class="text-center" (click)="loadMore()" *ngIf="!loadingMore && items.length > 0">
              Load More Records
            </a>
            <span *ngIf="loadingMore">
                        <i class="fa fa-spinner fa-pulse"></i>
                    </span>
          </p>
        </div>
      </div>
    </div>
  </div>

  <div class="panel-body" *ngIf="items && !loading && m.sort_attribute"
       [ngbCollapse]="IsCollapsed">
    <div cdkDropList
         id="{{ parentItem.globalid }}"
         (cdkDropListDropped)="drop($event.previousIndex,  $event.currentIndex, items, $event)"
         [cdkDropListData]="items">
      <table class="table table-striped">
        <thead>

        <tr>
          <th *ngIf="meta.sort_attribute" width="12px;"></th>
          <ng-template ngFor let-key [ngForOf]="m.display_fields">

            <th *ngIf="m.fields[key] && (m.fields[key].type !== 'field' || (m.fields[key].type === 'field' &&
                     m.fields[key].get_choices !== undefined) ||
                     (m.fields[key].type === 'field' &&
                     m.fields[key].read_only === true))"
                [innerHTML]="m.fields[key].label | toTrusted">
              {{key}}
            </th>
          </ng-template>
          <th *ngIf="m.notify !== undefined" style="width:25px">Notify</th>
          <th *ngIf="m.print !== undefined" style="width:25px">Print</th>
          <th *ngFor="let button of m.action_buttons" style="width: 25px;">{{button.label}}</th>
          <th *ngIf="meta.sort_attribute">Sort Order</th>
          <th *ngIf="m.permissions && m.permissions.write && !m.hide_delete_button" style="width:25px">Delete</th>
        </tr>
        <tr *ngIf="items.length === 0">
          <td style="text-align: center" [attr.colspan]="2 * m.display_fields.length">
            No Items Found.
          </td>
        </tr>
        </thead>
        <!-- Moved ng-repeat from tbody to tr -->
        <tbody>
        <!--      <ng-template cdkDrag ngFor let-item [ngForOf]="items" let-index="index" >-->
        <tr cdkDrag *ngFor="let item of items; index as i;" [cdkDragData]="item"
            [ngStyle]="m.subItems ? {'border-left': '#ddd 1px solid', 'border-top': '#ddd 1px solid', 'border-right': '#ddd 1px solid'} : null">
          <td style="width:12px;" *ngIf="meta.sort_attribute">
            <i style="cursor:pointer" ngbTooltip="Drag and drop here to reorder" class="fa fa-bars"></i>
          </td>
          <ng-template ngFor let-key [ngForOf]="m.display_fields">

            <td *ngIf="m.fields[key] && (m.fields[key].type !== 'field' || (m.fields[key].type === 'field' &&
        m.fields[key].get_choices !== undefined) ||
      (m.fields[key].type === 'field' &&
        m.fields[key].read_only === true))"
                [ngStyle]="m.permissions && m.permissions.write ? {'cursor': 'pointer'} : null"
                (click)="m.permissions && m.permissions.write && m !== undefined && open(foreignKey, item, $event)">
              <app-display-field [type]="m.fields[key].type" [value]="item[key]"
                                 [getChoices]="m.fields[key].get_choices"
                                 [choices]="m.fields[key].choices"></app-display-field>
            </td>
          </ng-template>
          <td *ngIf="meta.sort_attribute">{{ item[meta.sort_attribute] + 1 }}</td>
          <td *ngIf="m.notify !== undefined" style="cursor: pointer; vertical-align: middle;">
            <a (click)="m.notify.click(item)">
              <i class="fa fa-envelope fa-lg" style="padding:0px 30%; color: #000;"></i>
            </a>
          </td>
          <td *ngIf="m.print !== undefined" style="cursor: pointer; vertical-align: middle;">
            <a (click)="get(item, index)" *ngIf="!itemLoading[index]">
              <i class="fa fa-print fa-lg" style="padding:0px 30%; color: #000;"></i>
            </a>
            <span *ngIf="itemLoading[index]"><i style="padding:0px 30%; color: #000;"
                                                class="fa fa-spinner fa-pulse"></i></span>
          </td>
          <td *ngFor="let button of m.action_buttons" style="cursor: pointer; vertical-align: middle;">
            <a *ngIf="button.label != 'Send to Survey123'" (click)="button.func(item)">
              <i [ngClass]="'fa ' + button.icon + ' fa-lg'" style="padding:0px 30%; color: #000;"></i>
            </a>
          </td>
          <td *ngIf="m.permissions && m.permissions.write && !m.hide_delete_button"
              style="cursor: pointer; vertical-align: middle;"
              (click)="delete(item)"><i
            class="fa-regular fa-times-circle fa-lg"
            style="padding:0px 30%;"></i></td>
        </tr>
        <tr *ngIf="m.subItems"
            style="border-left: #ddd 1px solid; border-bottom: #ddd 1px solid; border-right: #ddd 1px solid;
                       background: none;">
          <td [attr.colspan]="(m.display_fields.length + (m.action_buttons ? m.action_buttons.length : 0))+3"
              style="padding-bottom: 0">
                    <span *ngFor="let subItemKey of m.subItems">
                        <app-nested-inline *ngIf="subItemKey.indexOf('attachment') < 0 && subItemKey.indexOf('review') < 0
                                                && item.globalid !== undefined && subItemKey.indexOf('payment') < 0
                                                && subItemKey.indexOf('locations') < 0"
                                           [meta]="m[subItemKey]" [items]="item[subItemKey]" [parentItem]="item"
                                           [foreignKey]="item.globalid">
                        </app-nested-inline>
                      <app-nested-inline *ngIf="subItemKey.indexOf('locations') > -1"
                                         [meta]="m[subItemKey]" [items]="item[subItemKey]" [parentItem]="item"
                                         [foreignKey]="item.globalid" [sorting]="item.groupname"></app-nested-inline>
                        <app-attachments *ngIf="subItemKey.indexOf('attachment') > -1 && item.globalid !== undefined"
                                         [type]="m[subItemKey].type" [meta]="m[subItemKey]" [foreignKey]="item.globalid"
                                         [useVerboseName]="m[subItemKey].use_verbose_name"></app-attachments>
                        <app-routing-review *ngIf="subItemKey.indexOf('review') > -1 && item.globalid !== undefined"
                                            [contentType]="m.content_type"
                                            [meta]="m[subItemKey]" [foreignKey]="item.globalid"></app-routing-review>
                        <app-payments-inline *ngIf="subItemKey.indexOf('payment') > -1 && item.globalid !== undefined"
                                             [contentType]="m.content_type"
                                             [meta]="m[subItemKey]" [parentItem]="item"></app-payments-inline>
                   </span>
          </td>
        </tr>
        <tr *ngIf="m.subItems" style="background: none">
          <td [attr.colspan]="m.display_fields.length+3"></td>
        </tr>
        <!--      </ng-template>-->
        </tbody>
      </table>
    </div>
    <div *ngIf="items.length < m.count">
      <div class="row">
        <div class="col-md-12">
          <p class="text-center">
            <a role="button" class="text-center" (click)="loadMore()" *ngIf="!loadingMore && items.length > 0">Load More
              Records</a>
            <span *ngIf="loadingMore">
                        <i class="fa fa-spinner fa-pulse"></i>
                    </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
